import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is FreeCRM really free for email, voice, and SMS?",
    a: "Yes — the Free plan includes email marketing, click-to-call, call logging, and 500 SMS messages per month at no cost. Paid plans unlock larger sending limits, advanced automation, call recording, and unlimited SMS.",
  },
  {
    q: "How is FreeCRM different from HubSpot?",
    a: "Unlike HubSpot, every channel is native — email marketing, voice, and SMS are all included, not sold as separate add-ons or costly integrations.",
  },
  {
    q: "Can I run email campaigns and sequences?",
    a: "Yes. Design broadcasts, drip campaigns, and multi-step sequences that mix email, SMS, and calls — with full open, click, and reply tracking.",
  },
  {
    q: "Can I port my existing phone numbers?",
    a: "Absolutely. You can bring your own numbers or purchase local numbers directly inside FreeCRM on Growth and Enterprise plans.",
  },
  {
    q: "Do you support two-way SMS?",
    a: "Yes. Send and receive SMS from the same inbox as your email, with templates, scheduled sends, and full conversation history per contact.",
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="bg-muted/40 py-24">
      <div className="container max-w-3xl">
        <div className="text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">FAQ</span>
          <h2 className="mt-3 font-display text-4xl font-bold text-secondary md:text-5xl">
            Questions, answered
          </h2>
        </div>
        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="rounded-xl border border-border bg-card px-6 shadow-card">
              <AccordionTrigger className="text-left font-display text-lg font-semibold text-secondary hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
